{{ params.value | currencyLocale: null : null : '1.2' | lT }}
<span *ngIf="isPriceInformationVisible()"> ({{ priceInformation$ | async | translate }})</span>
